define (require) ->

  #--------------

  Array::sortByKey = (key) ->
    @sort (a, b) ->
      x = a[key]
      y = b[key]
      if x < y then -1 else if x > y then 1 else 0

  #--------------

  Array::lastItem = ->
    @[@length-1]

  #--------------

  Array::noDupe = ->
    temp = {}
    i = 0
    while i < @length
      temp[@[i]] = true
      i++
    r = []
    for k of temp
      r.push k
    r



// WEBPACK FOOTER //
// ./coffee/extender/array-extender.coffee